// Programmatic Pendo events (non-click).
// For click tracking use data-pendo-key attributes instead.
import { sendEvent } from 'util/pendoTrack';
export const REVIEW_SETUP_COMPLETED = 'covidence.review.setup_completed';
export const REVIEW_SETUP_CRITERIA_SAVED =
  'covidence.review.setup_criteria_saved';

export const trackReviewSetupCompleted = ({
  review_id,
}: {
  review_id: string | null;
}) => {
  sendEvent(REVIEW_SETUP_COMPLETED, { review_id });
};

export const trackReviewSetupCriteriaSaved = ({
  review_id,
}: {
  review_id: string | null;
}) => {
  sendEvent(REVIEW_SETUP_CRITERIA_SAVED, { review_id });
};
